export default __webpack_public_path__ + "static/media/friendBook.a1f81f6d.PNG";